import global from '@/assets/js/global'
import axios from 'axios'

const path = 'firestoreForm2'

/*
 *  FORMS
 */

const get = async (params, token) => {
  const options = {
    params,
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)

  const forms = res.data.map(item => {
    // 轉換 school 物件成單獨 key
    if (item.school && typeof item.school === 'object') {
      item = {
        ...item,
        school: item.school.name,
        schoolLevel: item.school.level,
      }
    } else if (typeof item.school === 'string') {
      item = { ...item, schoolLevel: null }
    }
    return item
  })

  return forms
}

export default {
  get,
}
